'use strict';

// decalrations for current active image in carousel and carousel container
const $carouselContainer = $("#sp-carousel-modal-movil");
let $currentZoomImage

// initial zoom level for the images and default scale value for zooming in/out
let scale = 1;
const ZOOM_SPEED = 0.1;
const ZOOM_LEVELS = [1, 1.75, 2.5, 3.5];
let currentZoomLevel = 0;

// Función global para verificar si hay zoom activo
window.isZoomActive = function() {
    return currentZoomLevel > 0;
};

// flag to check if zooming out and dragging is enabled
let zoomOut = false;
let isDragging = false;

// variables to define axis position into image with the dragging
let startX;
let startY;
let initialX;
let initialY;

// Variables para el manejo del desplazamiento
let touchStartX = 0;

// Variables para el manejo de gestos
let isPinching = false;
let isZoomGesture = false;

/**
 * Function to start dragging the zoom image.
 * @param {Event} e - The event object
 */
function startDragging(e) {
    if (ZOOM_LEVELS[currentZoomLevel] <= 1) return;

    isDragging = true;

    // Normalizamos el evento para que funcione tanto en mouse como en touch
    const event = e.type.includes('mouse') ? e : e.originalEvent.touches[0];

    // Guardamos posición inicial del puntero
    startX = event.clientX || event.pageX;
    startY = event.clientY || event.pageY;

    // Obtenemos posición inicial de la imagen
    const transform = $currentZoomImage.css('transform');
    const matrix = new DOMMatrixReadOnly(transform);
    initialX = matrix.e;
    initialY = matrix.f;

    // Cambiamos cursor solo en dispositivos de escritorio
    if (e.type.includes('mouse')) {
        $currentZoomImage.css({'cursor': 'grabbing'});
    }
    
    e.preventDefault();
    if (e.type.includes('mouse')) {
        e.stopPropagation();
    }
}

/**
 * Function to handle dragging of the zoom image.
 * @param {Event} e - The event object
 */
function drag(e) {
    if (!isDragging) return;

    // Normalizamos el evento para que funcione tanto en mouse como en touch
    const event = e.type.includes('mouse') ? e : e.originalEvent.touches[0];

    // Calculamos desplazamiento del puntero
    const currentX = event.clientX || event.pageX;
    const currentY = event.clientY || event.pageY;
    
    const deltaX = currentX - startX;
    const deltaY = currentY - startY;

    // Calculamos nueva posición
    const newX = initialX + deltaX;
    const newY = initialY + deltaY;
    
    // Obtenemos dimensiones para limitar el movimiento
    const $container = $carouselContainer.find('.zoom-image-container');
    const containerWidth = $(".sp-line-modal-movil").width();
    const containerHeight = $container.height();
    const imageWidth = $currentZoomImage.width() * ZOOM_LEVELS[currentZoomLevel];
    const imageHeight = $currentZoomImage.height() * ZOOM_LEVELS[currentZoomLevel];
    
    // Calculamos la diferencia entre el tamaño de la imagen con zoom y el contenedor
    const diffX = Math.max(0, imageWidth - containerWidth);
    const diffY = Math.max(0, imageHeight - containerHeight);
    
    // Calculamos el desplazamiento máximo permitido en cada dirección
    const maxOffsetX = diffX / (2 * ZOOM_LEVELS[currentZoomLevel]);
    const maxOffsetY = diffY / (2 * ZOOM_LEVELS[currentZoomLevel]);
    
    // Aplicamos los límites al desplazamiento
    const limitedX = Math.max(Math.min(newX / ZOOM_LEVELS[currentZoomLevel], maxOffsetX), -maxOffsetX);
    const limitedY = Math.max(Math.min(newY / ZOOM_LEVELS[currentZoomLevel], maxOffsetY), -maxOffsetY);
    
    // Aplicamos la transformación sin transiciones durante el arrastre
    $currentZoomImage.css({
        'transform': `scale(${ZOOM_LEVELS[currentZoomLevel]}) translate(${limitedX}px, ${limitedY}px)`,
        'transition': 'none'
    });

    e.preventDefault();
    if (e.type.includes('mouse')) {
        e.stopPropagation();
    }
}

/**
 * Function to stop image dragging
 */
function stopDragging() {
    if (!isDragging) return;
    
    isDragging = false;
    
    // Restauramos cursor apropiado
    if (currentZoomLevel === 0) {
        $currentZoomImage.css({'cursor': 'zoom-in'});
    } else if (currentZoomLevel === ZOOM_LEVELS.length - 1) {
        $currentZoomImage.css({'cursor': 'move'});
    } else {
        $currentZoomImage.css({'cursor': 'zoom-in'});
    }
}

/**
 * function to enable/disable dragging of zoom images
 * @param {boolean} enable - Whether to enable or disable dragging
 */
function toggleDragging(enable) {
    if (enable) {
        $currentZoomImage
            .on('mousedown touchstart', startDragging)
            .on('mousemove touchmove', drag)
            .on('mouseup mouseleave touchend touchcancel', stopDragging);
    }
}

/**
 * Función para aplicar zoom en un punto específico de la imagen
 * @param {number} level - El nivel de zoom a aplicar
 * @param {number} pointX - Coordenada X del centro (relativa a la imagen)
 * @param {number} pointY - Coordenada Y del centro (relativa a la imagen)
 */
function applyZoomAtPoint(level, pointX, pointY) {
    if (level < 0 || level >= ZOOM_LEVELS.length) return;
    
    // Si no se especifica un punto, usamos el centro de la imagen
    let centerX = pointX;
    let centerY = pointY;
    
    if (centerX === undefined || centerY === undefined) {
        const imgWidth = $currentZoomImage.width();
        const imgHeight = $currentZoomImage.height();
        centerX = imgWidth / 2;
        centerY = imgHeight / 2;
    }
    
    // Obtenemos la transformación actual
    const currentTransform = $currentZoomImage.css('transform');
    const currentMatrix = new DOMMatrixReadOnly(currentTransform);
    
    // Calculamos el factor de escala nuevo y antiguo
    const newScale = ZOOM_LEVELS[level];
    const oldScale = ZOOM_LEVELS[currentZoomLevel];
    
    // Calculamos el desplazamiento para mantener el punto centrado
    // Solo aplicamos este cálculo si estamos cambiando de nivel de zoom
    let translateX = 0;
    let translateY = 0;
    
    if (level !== currentZoomLevel) {
        // Obtenemos dimensiones
        const $container = $carouselContainer.find('.zoom-image-container');
        const containerWidth = $(".sp-line-modal-movil").width();
        const containerHeight = $container.height();
        
        // Calculamos el punto relativo dentro de la imagen (de 0 a 1)
        const imgWidth = $currentZoomImage.width();
        const imgHeight = $currentZoomImage.height();
        const relativeX = centerX / imgWidth;
        const relativeY = centerY / imgHeight;
        
        // Calculamos el desplazamiento necesario para centrar en ese punto
        const scaledWidth = imgWidth * newScale;
        const scaledHeight = imgHeight * newScale;
        
        // El desplazamiento debe considerar la posición relativa del punto
        translateX = (containerWidth / 2 - scaledWidth * relativeX) / newScale;
        translateY = (containerHeight / 2 - scaledHeight * relativeY) / newScale;
        
        // Limitamos el desplazamiento para que la imagen no se salga del contenedor
        const diffX = Math.max(0, scaledWidth - containerWidth);
        const diffY = Math.max(0, scaledHeight - containerHeight);
        
        const maxOffsetX = diffX / (2 * newScale);
        const maxOffsetY = diffY / (2 * newScale);
        
        translateX = Math.max(Math.min(translateX, maxOffsetX), -maxOffsetX);
        translateY = Math.max(Math.min(translateY, maxOffsetY), -maxOffsetY);
    }
    
    // Aplicamos el nuevo zoom con la transformación calculada
    $currentZoomImage.css({
        'transform': `scale(${newScale}) translate(${translateX}px, ${translateY}px)`,
        'transition': 'transform 0.3s ease'
    });
    
    // Actualizamos el nivel de zoom
    currentZoomLevel = level;
    
    // Actualizamos el cursor según el nivel
    if (level === 0) {
        $currentZoomImage.css({'cursor': 'zoom-in'});
    } else if (level === ZOOM_LEVELS.length - 1) {
        $currentZoomImage.css({'cursor': 'move'});
    } else {
        $currentZoomImage.css({'cursor': 'zoom-in'});
    }
    
    // Activamos o desactivamos el arrastre según el nivel de zoom
    toggleDragging(newScale > 1);
}

/**
 * Function to update the current zoom level style in the current carousel image
 * @param {number} level - level variable to apply in image scale style
 */
function applyZoom(level) {
    // Llamamos a la nueva función más completa pasando solo el nivel
    applyZoomAtPoint(level);
}

$(document).ready(function () {
    // Variables para detectar triple toque
    let lastTapTime = 0;
    let tapCount = 0;
    const TRIPLE_TAP_THRESHOLD = 300; // Reducimos el tiempo para hacerlo más sensible en iOS

    // Configurar el carrusel para permitir deslizamiento táctil
    $carouselContainer.carousel({
        touch: false,
        swipe: false,
        interval: false
    });

    /**
     * Función para restablecer el zoom
     */
    function resetZoom() {
        currentZoomLevel = 0;
        scale = 1;
        if ($currentZoomImage) {
            $currentZoomImage.css({
                'transform': 'scale(1) translate(0, 0)',
                'transition': 'transform 0.3s ease'
            });
            $currentZoomImage.css({'cursor': 'zoom-in'});
        }
        isPinching = false;
        isZoomGesture = false;
        isDragging = false;
        zoomOut = false;
    }

    // Solo permitir navegación con los botones cuando hay zoom
    $('.carousel-control-prev, .carousel-control-next').on('click', function(e) {
        const direction = $(this).hasClass('carousel-control-prev') ? 'prev' : 'next';
        
        // Primero restablecer el zoom
        resetZoom();
        
        // Luego navegar al siguiente/anterior slide
        $carouselContainer.carousel(direction);
    });

    // Prevenir cualquier interacción con el carrusel cuando hay zoom o dos dedos
    $carouselContainer.on('touchstart mousedown', function(e) {
        const touches = e.originalEvent && e.originalEvent.touches;
        const isTouchEvent = e.type === 'touchstart';
        const isClickOnArrow = $(e.target).closest('.carousel-control-prev, .carousel-control-next').length > 0;
        
        // Si es un evento táctil y hay zoom activo, pero NO es un clic en flecha, prevenir eventos
        if (isTouchEvent && currentZoomLevel > 0 && !isClickOnArrow) {
            e.preventDefault();
            e.stopPropagation();
            $carouselContainer.carousel('pause');
            return false;
        }

        // Si hay dos dedos y NO es un gesto en la imagen, prevenir eventos
        if (touches && touches.length >= 2 && !$(e.target).closest('.zoom-image-container img').length) {
            e.preventDefault();
            e.stopPropagation();
            $carouselContainer.carousel('pause');
            return false;
        }

        // Guardar posición inicial del toque
        if (touches && touches.length === 1) {
            touchStartX = touches[0].pageX;
        }
        
        return true;
    });

    $carouselContainer.on('touchmove', function(e) {
        const touches = e.originalEvent && e.originalEvent.touches;
        const isOnImage = $(e.target).closest('.zoom-image-container img').length > 0;
        const isOnArrow = $(e.target).closest('.carousel-control-prev, .carousel-control-next').length > 0;
        
        // Si hay dos dedos en la imagen, permitir para zoom
        if (touches && touches.length === 2 && isOnImage) {
            return true; // Permitir gestos de zoom en la imagen
        }
        
        // Si hay zoom activo pero no es en flecha, prevenir eventos de desplazamiento
        if (currentZoomLevel > 0 && !isOnArrow) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        // Si no hay zoom y es un solo dedo, permitir el desplazamiento
        if (currentZoomLevel === 0 && touches && touches.length === 1) {
            const deltaX = touches[0].pageX - touchStartX;
            
            if (Math.abs(deltaX) > 50) { // Umbral para deslizamiento
                if (deltaX > 0) {
                    $carouselContainer.carousel('prev');
                } else {
                    $carouselContainer.carousel('next');
                }
                touchStartX = touches[0].pageX; // Resetear la posición inicial
            }
        }
        
        return true;
    });

    $carouselContainer.on('touchend', function(e) {
        touchStartX = 0; // Resetear la posición inicial al terminar el toque
        return true;
    });

    /**
     * Function to setting next active image into carousel.
     */
    function setupZoom() {
        $currentZoomImage = $carouselContainer.find(".carousel-item.active .zoom-image-container img");

        scale = 1;
        zoomOut = false;
        $currentZoomImage.css({
            'transform': 'scale(' + scale +')'
        });

        // Touch Events
        let initialDistance = 0;
        let initialZoomLevel = 0;
        let touchStartY = 0;

        /**
         * Function to get Distance between pinch and zoom touches
         * @param {Object} touch1 - First touch point
         * @param {Object} touch2 - Second touch point
         * @return {number} - Distance between touch points
         */
        function getDistance(touch1, touch2) {
            return Math.hypot(
                touch1.pageX - touch2.pageX, 
                touch1.pageY - touch2.pageY
            );
        }

        // Limpia todos los eventos anteriores antes de configurar nuevos
        $currentZoomImage.off("wheel click dblclick touchstart touchmove touchend mousedown mouseup mousemove");

        // Agregamos una variable para rastrear el último tiempo de clic
        let lastClickTime = 0;
        
        // Reemplazamos el evento dblclick con una implementación personalizada usando click
        $currentZoomImage.on("click", function(e) {
            // Evitamos la propagación y el comportamiento predeterminado
            e.preventDefault();
            e.stopPropagation();
            
            // En dispositivos táctiles, ignoramos este gestor de clics
            if (e.originalEvent && e.originalEvent.touches) {
                return true;
            }
            
            // Obtenemos el tiempo actual
            const currentTime = new Date().getTime();
            
            // Si estamos en medio de un arrastre, ignoramos el clic
            if (isDragging) {
                return false;
            }
            
            // Tiempo máximo entre clics para considerarlo un doble clic (en milisegundos)
            const DOUBLE_CLICK_THRESHOLD = 300;
            
            // Si el tiempo entre este clic y el anterior es menor que el umbral, lo consideramos doble clic
            if (currentTime - lastClickTime < DOUBLE_CLICK_THRESHOLD) {
                // Lógica para cambiar el nivel de zoom
                if (currentZoomLevel === ZOOM_LEVELS.length - 1) {
                    currentZoomLevel--;
                    zoomOut = true;
                } else if (currentZoomLevel === 0) {
                    currentZoomLevel++;
                    zoomOut = false;
                } else if (zoomOut) {
                    currentZoomLevel--;
                } else {
                    currentZoomLevel++;
                }
                
                // Aplicamos el zoom centrado en el punto de clic
                const imageOffset = $currentZoomImage.offset();
                const clickX = e.pageX - imageOffset.left;
                const clickY = e.pageY - imageOffset.top;
                
                // Aplicamos el zoom con una transformación centrada en el punto de clic
                applyZoomAtPoint(currentZoomLevel, clickX, clickY);
                
                // Reiniciamos el tiempo del último clic para evitar dobles activaciones
                lastClickTime = 0;
                return true;
            }
            
            // Guardamos el tiempo del clic actual para la próxima comparación
            lastClickTime = currentTime;
            return true;
        });

        // Mantenemos el evento de rueda de mouse pero mejoramos el centrado del zoom
        $currentZoomImage.on("wheel", function(e) {
            e.preventDefault();
            
            if (e.originalEvent.deltaY < 0) {
                // Zoom in
                currentZoomLevel = Math.min(currentZoomLevel + 1, ZOOM_LEVELS.length - 1);
            } else {
                // Zoom out
                currentZoomLevel = Math.max(currentZoomLevel - 1, 0);
            }
            
            // Obtener la posición del cursor dentro de la imagen para centrar el zoom
            const imageOffset = $currentZoomImage.offset();
            const mouseX = e.pageX - imageOffset.left;
            const mouseY = e.pageY - imageOffset.top;
            
            // Aplicar zoom centrado en la posición del cursor
            applyZoomAtPoint(currentZoomLevel, mouseX, mouseY);
            return true;
        });
        
        // Triple toque para resetear zoom
        $currentZoomImage.on('touchstart', function(e) {
            const touches = e.originalEvent.touches;
            
            // Para triple toque
            if (touches.length === 1) {
                const currentTime = new Date().getTime();
                const tapTimeDiff = currentTime - lastTapTime;

                if (tapTimeDiff < TRIPLE_TAP_THRESHOLD) {
                    tapCount++;
                    
                    if (tapCount === 3) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        // Solo resetear si hay zoom activo
                        if (currentZoomLevel > 0) {
                            resetZoom();
                        }
                        
                        tapCount = 0;
                        lastTapTime = 0;
                        return false;
                    }
                } else {
                    tapCount = 1;
                }
                
                lastTapTime = currentTime;
            }
            
            // Detectar pinch zoom (2 dedos)
            if (touches.length === 2) {
                e.preventDefault();
                e.stopPropagation();
                isPinching = true;
                isZoomGesture = true;
                
                initialDistance = getDistance(touches[0], touches[1]);
                initialZoomLevel = currentZoomLevel;

                return false;
            }

            // Para un solo dedo con zoom activo
            if (touches.length === 1 && currentZoomLevel > 0) {
                touchStartX = touches[0].pageX;
                touchStartY = touches[0].pageY;
                
                // Si hay zoom activo, permitir arrastre
                if (currentZoomLevel > 0) {
                    startDragging(e);
                }
            }
            
            return true; // Valor de retorno por defecto
        });

        $currentZoomImage.on('touchmove', function(e) {
            const touches = e.originalEvent.touches;
            
            // Manejar gesto de pinch zoom
            if (touches.length === 2 && isPinching) {
                e.preventDefault();
                e.stopPropagation();
                
                const currentDistance = getDistance(touches[0], touches[1]);
                const scaleDiff = currentDistance / initialDistance;

                // Ajustar la sensibilidad del zoom
                if (Math.abs(1 - scaleDiff) > 0.1) {
                    let newZoomLevel;
                    
                    // Para zoom out (acercar dedos)
                    if (scaleDiff < 0.8) {
                        newZoomLevel = Math.max(currentZoomLevel - 1, 0);
                    } 
                    // Para zoom in (alejar dedos)
                    else if (scaleDiff > 1.2) {
                        newZoomLevel = Math.min(currentZoomLevel + 1, ZOOM_LEVELS.length - 1);
                    }

                    if (newZoomLevel !== undefined && newZoomLevel !== currentZoomLevel) {
                        currentZoomLevel = newZoomLevel;
                        
                        // Calcular el punto central entre los dos dedos
                        const centerX = (touches[0].pageX + touches[1].pageX) / 2;
                        const centerY = (touches[0].pageY + touches[1].pageY) / 2;
                        
                        // Obtener la posición relativa a la imagen
                        const imageOffset = $currentZoomImage.offset();
                        const pointX = centerX - imageOffset.left;
                        const pointY = centerY - imageOffset.top;
                        
                        // Aplicar zoom en el punto central del gesto
                        applyZoomAtPoint(currentZoomLevel, pointX, pointY);

                        // Actualizar la distancia inicial para el siguiente gesto
                        initialDistance = currentDistance;
                    }
                }
                
                return false;
            } 
            
            // Manejar arrastre de imagen con un dedo cuando hay zoom
            if (currentZoomLevel > 0 && touches.length === 1) {
                e.preventDefault();
                e.stopPropagation();
                drag(e);
                return false;
            }
            
            return true;
        });

        $currentZoomImage.on('touchend touchcancel', function(e) {
            // Reset de variables después del gesto de pinch
            if (isPinching) {
                e.preventDefault();
                e.stopPropagation();
                
                isPinching = false;
                isZoomGesture = false;
                initialDistance = 0;
                stopDragging();
                
                return false;
            }
            
            // Reset variables de arrastre
            stopDragging();
            return true;
        });

        // Eventos de ratón complementarios para escritorio
        $currentZoomImage.on("mousedown", function(e) {
            if (currentZoomLevel >= 1) {
                $currentZoomImage.css({'cursor': 'move'});
            }
        });

        $currentZoomImage.on("mouseup", function(e) {
            if (!isDragging) {
                const cursorZoom = zoomOut ? "zoom-out" : "zoom-in";
                $currentZoomImage.css({'cursor': cursorZoom});
            }
        });
    }

    $carouselContainer.on('slid.bs.carousel', function () {
        // Reset and config new current image
        scale = 1;
        currentZoomLevel = 0;
        $currentZoomImage.css({'transform': 'scale(' + scale +')'});
        setupZoom();
    });

    $(document).on('click', '#set-container', function () {
        // Reset and config new current image
        scale = 1;
        currentZoomLevel = 0;
        $currentZoomImage.css({'transform': 'scale(' + scale +')'});
        setupZoom();
    });

    setupZoom();
});
